import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { BUTTON_HEIGHT_40 } from '../../../Button'
import { InputWrapError } from '../../../Input'
import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'
import { getContactQaName } from '../ProfileContactsWidget.utils'
import { ProfileContactsWidgetLabel } from '../ProfileContactsWidgetLabel'
import { getErrorBorderStyle } from '../ProfileContactsWidgetListCell'
import { ProfileContactsWidgetListCellButton } from '../ProfileContactsWidgetListCellButton'
import { ProfileContactsWidgetListCellEditInput } from '../ProfileContactsWidgetListCellEditInput'

import { getNewContactFieldProps } from './ProfileContactsWidgetCreateFormField.utils'

import * as styles from './ProfileContactsWidgetCreateFormField.module.css'

function ProfileContactsWidgetCreateFormField({
  autoFocus,
  contact,
  name,
  onDelete,
}) {
  const { t } = useTranslation()

  const { errors, isSubmitting, submitCount, values } = useFormikContext()

  const { id, typeConfig } = contact

  const { fieldError, fieldName, isFieldError } = getNewContactFieldProps({
    contact,
    errors,
    name,
    submitCount,
    values,
  })

  function handleGetErrorProps(error) {
    return error && submitCount > 0 ? { showError: true } : EMPTY_OBJECT
  }

  return (
    <div className={styles.input}>
      <ProfileContactsWidgetLabel
        isSecondary
        infoTooltipKey={typeConfig.infoTooltipKey}
        label={t(typeConfig.labelKey)}
      />
      <div className={styles.inputRow}>
        <div className={styles.inputField}>
          <ProfileContactsWidgetListCellEditInput
            autoFocus={autoFocus}
            getErrorProps={handleGetErrorProps}
            name={fieldName}
            typeConfig={typeConfig}
          />
        </div>
        <ProfileContactsWidgetListCellButton
          disabled={isSubmitting}
          height={BUTTON_HEIGHT_40}
          qaName={getContactQaName({
            id,
            qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.deleteButton,
          })}
          style={getErrorBorderStyle(isFieldError)}
          tooltip={t('ProfileContactsWidget.DeleteBtnKey')}
          onClick={onDelete}
        />
      </div>
      {fieldError ? <InputWrapError text={fieldError} /> : null}
    </div>
  )
}

export default ProfileContactsWidgetCreateFormField
